import PES from './images/Sport/PES.png'
import COD from './images/Action/callOfDuty.jpg'
import TS2 from './images/Tactic/ThorStarcraft2.jpg'
import CVZ from './images/Tactic/Civilization.jpg'
import CCS from './images/Tactic/CommandandConquerseries.jpg'
import DWS from './images/Tactic/Warhammer40,000DawnofWarseries.jpg'
import TWS from './images/Tactic/TotalWarseries.jpg'
import WCR from './images/Tactic/Warcraft.jpg'
import LIMBO from './images/Puzzles/LIMBO.jpg'
import DBF from './images/Fighting/DragonballFighterZ.jpg'
import KOF from './images/Fighting/KOF.jpg'
import ASC from './images/Action/AssassinCreed.jpg'
import BTF from './images/Action/Battlefield.jpg'
import FC5 from './images/Action/FarCry5.jpg'
import TBR from './images/Action/Tombraider.png'
import TWD from './images/Action/TheWalkingDead.jpg'
import MN20 from './images/Sport/MaddenNFL20.jpg'
import NHL from './images/Sport/NHL2020.jpg'
import MLB from './images/Sport/MLB.jpg'
import NBA from './images/Sport/NBA.jpg'
import UFC from './images/Sport/UFC.jpg'
import SS from './images/Fighting/SamuraiShodown.jpg'
import STF from './images/Fighting/StreetFighter.jpg'
import JF from './images/Fighting/JumpForce.jpg'
import Soulcalibur from './images/Fighting/Soulcalibur.jpg'
import Tekken from './images/Fighting/Tekken.jpg'
import TWN from './images/Puzzles/TheWitness.png'
import METAMORPHOSIS from './images/Puzzles/METAMORPHOSIS.png'
import Inside from './images/Puzzles/Inside.jpg'
import LNM from './images/Puzzles/LittleNightmares.jpg'
import EVERGATE from './images/Puzzles/EVERGATE.jpg'

export const WorkData = [
    {
        gameName: "Call Of Duty",
        imgURL: COD,
        tag: "ACTION",
        videoLink: "https://www.youtube.com/watch?v=JzOrZVpuJH8&ab_channel=CallofDuty"
    },
    {
        gameName: "PES 2020",
        imgURL: PES,
        tag: "SPORT",
        videoLink: "https://youtu.be/_89i5H1zAeU"
    },
    {
        gameName: "Thor Starcraft 2",
        imgURL: TS2,
        tag: "TACTIC",
        videoLink: "https://youtu.be/MVbeoSPqRs4"
    },
    {
        gameName: "Civilization",
        imgURL: CVZ,
        tag: "TACTIC",
        videoLink: "https://youtu.be/5KdE0p2joJw"

    },
    {
        gameName: "LIMBO",
        imgURL: LIMBO,
        tag: "PUZZLES",
        videoLink: "https://youtu.be/Y4HSyVXKYz8"
    },
    {
        gameName: "Dragonball Fighter Z",
        imgURL: DBF,
        tag: "FIGHTING",
        videoLink: "https://youtu.be/A-Eb1tAczEk"
    },
    {
        gameName: "NHL 2020",
        imgURL: NHL,
        tag: "SPORT",
        videoLink: "https://youtu.be/wV7Uv-ftCLQ"
    },
    {
        gameName: "King Of Fighter",
        imgURL: KOF,
        tag: "FIGHTING",
        videoLink: "https://youtu.be/TU0mcq6Z7xs"
    },
    {
        gameName: "Samurai Shodown",
        imgURL: SS,
        tag: "FIGHTING",
        videoLink: "https://youtu.be/YILerS7DVEU"
    },
    {
        gameName: "Assassin's Creed",
        imgURL: ASC,
        tag: "ACTION",
        videoLink: "https://youtu.be/xzCEdSKMkdU"
    },
    {
        gameName: "Battlefield",
        imgURL: BTF,
        tag: "ACTION",
        videoLink: "https://youtu.be/ASzOzrB-a9E"
    },
    {
        gameName: "NBA 2K19",
        imgURL: NBA,
        tag: "SPORT",
        videoLink: "https://youtu.be/bIzP0En2aZ4"
    },
    {
        gameName: "Far Cry 5",
        imgURL: FC5,
        tag: "ACTION",
        videoLink: "https://youtu.be/Kdaoe4hbMso"
    },
    {
        gameName: "MLB The Show 19",
        imgURL: MLB,
        tag: "SPORT",
        videoLink: "https://youtu.be/pf9JwMpUzwI"
    },
    {
        gameName: "Soulcalibur",
        imgURL: Soulcalibur,
        tag: "FIGHTING",
        videoLink: "https://youtu.be/0S-uXOwrRYI"
    },
    {
        gameName: "Command and Conquer series",
        imgURL: CCS,
        tag: "TACTIC",
        videoLink: "https://youtu.be/5NbfwB-UlcE"
    },
    {
        gameName: "Tekken",
        imgURL: Tekken,
        tag: "FIGHTING",
        videoLink: "https://youtu.be/kKLCwDg2JLA"
    },
    {
        gameName: "Tomb Raider",
        imgURL: TBR,
        tag: "ACTION",
        videoLink: "https://youtu.be/XYtyeqVQnRI"
    },
    {
        gameName: "Total War series",
        imgURL: TWS,
        tag: "TACTIC",
        videoLink: "https://youtu.be/aOP1YugqRDk"
    },
    {
        gameName: "The Walking Dead",
        imgURL: TWD,
        tag: "ACTION",
        videoLink: "https://youtu.be/q_uu9-kLM2w"
    },
    {
        gameName: "Warhammer 40,000 Dawn of War series",
        imgURL: DWS,
        tag: "TACTIC",
        videoLink: "https://youtu.be/gN8geCTlZOo"
    },
    {
        gameName: "Madden NFL 20",
        imgURL: MN20,
        tag: "SPORT",
        videoLink: "https://youtu.be/oHOudL5d14M"
    },
    {
        gameName: "UFC 3",
        imgURL: UFC,
        tag: "SPORT",
        videoLink: "https://youtu.be/Pgh7dGxVKWw"
    },
    {
        gameName: "Street Fighter",
        imgURL: STF,
        tag: "FIGHTING",
        videoLink: "https://youtu.be/0nFd7Iylj5A"
    },
    {
        gameName: "Jump Force",
        imgURL: JF,
        tag: "FIGHTING",
        videoLink: "https://youtu.be/D02r3Ph9tM8"
    },
    {
        gameName: "Warcraft",
        imgURL: WCR,
        tag: "TACTIC",
        videoLink: "https://youtu.be/jSJr3dXZfcg"
    },
    {
        gameName: "The Witness",
        imgURL: TWN,
        tag: "PUZZLES",
        videoLink: "https://youtu.be/9ytwNUMdbcE"
    },
    {
        gameName: "Inside",
        imgURL: Inside,
        tag: "PUZZLES",
        videoLink: "https://youtu.be/yDm6PAgNohU"
    },
    {
        gameName: "Little Nightmares II",
        imgURL: LNM,
        tag: "PUZZLES",
        videoLink: "https://youtu.be/TP_BJJm-n0g"
    },
    {
        gameName: "EVERGATE",
        imgURL: EVERGATE,
        tag: "PUZZLES",
        videoLink: "https://youtu.be/5gA4Zp0Y-qE"
    },
    {
        gameName: "METAMORPHOSIS",
        imgURL: METAMORPHOSIS,
        tag: "PUZZLES",
        videoLink: "https://youtu.be/QRmIqfG7n3w"
    },
]